

export const updatedSort = (table) => {
    if (!Array.isArray(table)) return table

    return [].concat(table).sort((a1, a2) => {
        return a2?.updatedAt - a1?.updatedAt
    })
}
